module.exports = __webpack_public_path__ + "img/subject_1.29ced661.png";